import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import DsAttendanceCard from './DsAttendanceCard.vue'
import DsAttendanceRequestCard from './DsAttendanceRequestCard.vue'
import { isRequestListItem, type AttendanceListItem } from '../utils/attendance-list-item'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceListCard',
  props: {
    item: {}
  },
  emits: ["details"],
  setup(__props: any, { emit }) {

/**
 * Um item da Lista da fila de registros: escolhe entre o card de cobrança e o card de
 * registro. Fonte única do card da Lista — a fila do `Index.vue` e a visão Lista nova o
 * usam, em vez de cada uma repetir os ~30 bindings.
 *
 * F3/M3 (balão ③) — a solicitação automática tem card PRÓPRIO. O `DsAttendanceCard` não
 * muda: ele continua servindo folha e Registro de Atividade, e item sem `requestedLeg`
 * (backend anterior à F3) cai sempre nele.
 *
 * O CTA "Enviar registro" do card leva ao MESMO destino do "Ver detalhes" (a tela de
 * aguardando envio do container), que é onde o envio da cobrança acontece: a fila não tem o
 * contexto de vaga que o modal de Registro de Atividade exige (I7/§8.2) e abrir um modal sem
 * ele deixaria o auditor num passo 2 sem saída.
 */




return (_ctx: any,_cache: any) => {
  return (_unref(isRequestListItem)(_ctx.item))
    ? (_openBlock(), _createBlock(DsAttendanceRequestCard, {
        key: 0,
        "attendance-id": _ctx.item.attendanceId,
        date: _ctx.item.date,
        unit: _ctx.item.unit,
        schedule: _ctx.item.schedule,
        shifts: _ctx.item.shifts,
        "doctor-name": _ctx.item.doctorName ?? null,
        "doctor-crm": _ctx.item.doctorCrm ?? null,
        "requested-leg": _ctx.item.requestedLeg ?? null,
        "request-channel": _ctx.item.requestChannel ?? null,
        "expected-submission-at": _ctx.item.expectedSubmissionAt ?? null,
        "created-at": _ctx.item.createdAt ?? null,
        timezone: _ctx.item.timezone ?? null,
        "is-overdue": _ctx.item.isOverdue ?? null,
        onDetails: _cache[0] || (_cache[0] = ($event: any) => (emit('details', $event))),
        onSendRecord: _cache[1] || (_cache[1] = ($event: any) => (emit('details', $event)))
      }, null, 8, ["attendance-id", "date", "unit", "schedule", "shifts", "doctor-name", "doctor-crm", "requested-leg", "request-channel", "expected-submission-at", "created-at", "timezone", "is-overdue"]))
    : (_openBlock(), _createBlock(DsAttendanceCard, {
        key: 1,
        "data-testid": "ds-attendance-lista-card",
        attendanceId: _ctx.item.attendanceId,
        date: _ctx.item.date,
        submissionDate: _ctx.item.submissionDate,
        unit: _ctx.item.unit,
        schedule: _ctx.item.schedule,
        shifts: _ctx.item.shifts,
        shiftsCount: _ctx.item.shiftsCount,
        status: _ctx.item.status,
        "has-antecipe": _ctx.item.hasAntecipe,
        "has-in-cash": _ctx.item.hasInCash,
        "has-divergent-entries": _ctx.item.hasDivergentEntries === true,
        "station-changed-after-audit": _ctx.item.stationChangedAfterAudit === true,
        "has-schedule-expected": _ctx.item.hasScheduleExpected,
        "manual-review-reason": _ctx.item.manualReviewReason ?? null,
        "approval-mode": _ctx.item.approvalMode ?? null,
        kind: _ctx.item.kind ?? null,
        "activity-type": _ctx.item.activityType ?? null,
        "activity-type-label": _ctx.item.activityTypeLabel ?? null,
        "activity-description": _ctx.item.activityDescription ?? null,
        "covered-legs": _ctx.item.coveredLegs ?? null,
        "declared-checkin": _ctx.item.declaredCheckin ?? null,
        "declared-checkout": _ctx.item.declaredCheckout ?? null,
        timezone: _ctx.item.timezone ?? null,
        "doctor-name": _ctx.item.doctorName ?? null,
        "doctor-crm": _ctx.item.doctorCrm ?? null,
        "attachment-count": _ctx.item.attachmentCount ?? null,
        "submitted-by-name": _ctx.item.submittedByName ?? null,
        "activity-risk-flags": _ctx.item.activityRiskFlags ?? null,
        "effective-summary": _ctx.item.effectiveSummary ?? null,
        "after-closure": _ctx.item.afterClosure === true,
        "legacy-migrated": _ctx.item.legacyMigrated === true,
        onDetails: _cache[2] || (_cache[2] = ($event: any) => (emit('details', $event)))
      }, null, 8, ["attendanceId", "date", "submissionDate", "unit", "schedule", "shifts", "shiftsCount", "status", "has-antecipe", "has-in-cash", "has-divergent-entries", "station-changed-after-audit", "has-schedule-expected", "manual-review-reason", "approval-mode", "kind", "activity-type", "activity-type-label", "activity-description", "covered-legs", "declared-checkin", "declared-checkout", "timezone", "doctor-name", "doctor-crm", "attachment-count", "submitted-by-name", "activity-risk-flags", "effective-summary", "after-closure", "legacy-migrated"]))
}
}

})